import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from "@auth0/auth0-react";
import AuthenticatedApp from './AuthenticatedApp';
import { getConfig } from "./config";
import SupabaseAuthBridge from './auth/SupabaseAuthBridge';

const onRedirectCallback = (appState) => {
  console.log('On Redirect Callback');
};

const auth0Config = getConfig();

const providerConfig = {
  domain: auth0Config.domain,
  clientId: auth0Config.clientId,
  onRedirectCallback,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: auth0Config.audience,
    scope: "openid profile email"
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Auth0Provider {...providerConfig}>
      <SupabaseAuthBridge />
      <AuthenticatedApp>
        <App />
      </AuthenticatedApp>
    </Auth0Provider>
);

reportWebVitals();
